export const fetchOrgRaterGroupsStart = (state, payload) => {
    return {
        ...state,
        fetchOrgRaterGroupsApi: {
            ...state.fetchOrgRaterGroupsApi,
            isProcessing: true,
            error: false,
        }


    };
};

export const fetchOrgRaterGroupsSuccess = (state, payload) => {
    return {
        ...state,
        fetchOrgRaterGroupsApi: {
            ...state.fetchOrgRaterGroupsApi,
            isProcessing: false,
            error: false,
            data: payload.data && payload.data.data ? payload.data.data : null
        },
        benchmarkFiltersAnalysis: {
            ...state.benchmarkFiltersAnalysis,
            raterGroups: payload.data && payload.data.data && payload.data.data.allRaterGroups ? payload.data.data.allRaterGroups : []
        },

        isOrgRaterGroupsFetched: true

    };
};

export const fetchOrgRaterGroupsFail = (state, payload) => {
    return {
        ...state,
        fetchOrgRaterGroupsApi: {
            ...state.fetchOrgRaterGroupsApi,
            isProcessing: false,
            error: true,
            data: null
        },
        isOrgRaterGroupsFetched: false

    };
};
